/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geotopcities2Inputs */

const en_geotopcities2 = /** @type {(inputs: Geotopcities2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most active places`)
};

const de_geotopcities2 = /** @type {(inputs: Geotopcities2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivste Orte`)
};

/**
* | output |
* | --- |
* | "Most active places" |
*
* @param {Geotopcities2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geotopcities2 = /** @type {((inputs?: Geotopcities2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geotopcities2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geotopcities2(inputs)
	return de_geotopcities2(inputs)
});
export { geotopcities2 as "geoTopCities" }